import { render, staticRenderFns } from "./advgroupuser.vue?vue&type=template&id=6c23ef4c"
import script from "./advgroupuser.vue?vue&type=script&lang=js"
export * from "./advgroupuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports